import {
  LiveUserInfo,
} from '@panda/cache/src/live/define';
import { ANSWER_CORRECT_TYPE } from '@panda/cache/src/question/define';
import { AnchorType } from '@panda/cache/src/unitResource/define';

export interface TeacherStatus {
  playVideo: boolean;
  playAudio: boolean;
}

export interface SpeakerInfo {
  account: string;
  hasCamera: boolean;
}

export interface LiveTeacherInfo {
  account: string;
  hasCamera: boolean;
  hasAudio: boolean;
}

export interface LiveMemberInfo extends LiveUserInfo {
  account: string;
  integral: number;
  hasCamera: boolean;
  hasAudio: boolean;
}

export enum SPEAK_STATUS {
  NORMAl = 0,
  CALLING,
  ACCEPTED,
  REFUSED,
}

export interface LivePushScreenData {
  isPushing: boolean;
  type: AnchorType;
  pushId: number;
  pushTime: number;
  data: {
    reward: number; // 星力值奖励
    content: string; // 前端 题目questionId 答题器 1,2,3-1,3
    contentUrl: string;
  };
}

export interface LivePushAnswer {
  answer: string;
  result: ANSWER_CORRECT_TYPE;
}

export const LAST_PUSH_ID = 'STEAM_LAST_PUSH_ID';

export const LIVE_INTEGRAL = 'STEAM_LIVE_INTEGRAL';
